module.exports = __webpack_public_path__ + "static/media/bowen-50.633652f9.jpg";